import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Nosotros from "@/components/Nosotros";
import Principios from "@/components/Principios";
import Servicios from "@/components/Servicios";
import Diferenciadores from "@/components/Diferenciadores";
import Contacto from "@/components/Contacto";
import Footer from "@/components/Footer";
import useLenis from "@/hooks/useLenis";

const Landing = () => {
  useLenis();
  return (
    <main className="font-body text-[#17351D]" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Nosotros />
      <Principios />
      <Servicios />
      <Diferenciadores />
      <Contacto />
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#17351D",
            color: "#fff",
            border: "1px solid rgba(193,200,42,0.3)",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
